import { Input, Form } from 'antd'
import { TextAreaProps as AntTextAreaProps } from 'antd/es/input'

const { TextArea: AntTextArea } = Input

export interface TextAreaProps extends AntTextAreaProps {
  /**
   * Label text displayed above the textarea
   */
  label?: string

  /**
   * Error message to display
   */
  error?: string

  /**
   * Helper text displayed below the textarea
   */
  helperText?: string

  /**
   * Mark the field as required
   */
  required?: boolean

  /**
   * Full width textarea
   */
  block?: boolean
}

/**
 * TextArea Component
 *
 * A multi-line text input field with label, error, and helper text support.
 *
 * @example
 * <TextArea
 *   label="Description"
 *   placeholder="Enter description"
 *   rows={4}
 * />
 *
 * @example
 * // TextArea with auto-resize
 * <TextArea
 *   label="Comments"
 *   autoSize={{ minRows: 3, maxRows: 6 }}
 * />
 */
export function TextArea({
  label,
  error,
  helperText,
  required,
  block = true,
  ...props
}: TextAreaProps) {
  // If there's a label, wrap in Form.Item for consistent styling
  if (label || error || helperText) {
    return (
      <Form.Item
        label={label}
        required={required}
        validateStatus={error ? 'error' : undefined}
        help={error || helperText}
        className="mb-6"
      >
        <AntTextArea style={block ? { width: '100%' } : undefined} {...props} />
      </Form.Item>
    )
  }

  // Standalone textarea without label
  return <AntTextArea style={block ? { width: '100%' } : undefined} {...props} />
}
